import storage from '../../../storage';
import logger from "../../../logger.js";
import ExceptionBadResponse from "@/exceptions/ExceptionBadResponse.js";
// setup query endpoint
const secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
const endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY;
// import Axios
import Axios from 'axios';
// instantiate axios
const axios = Axios.create();

async function createOrganization(organization) {
    let token = await storage.getToken();
    return axios.post(endpoint + '/api/services-new/profiles/organizations', organization, {
            headers: {
                Authorization: token
            }
        }) // eslint-disable-next-line
        .then(response => {
            return response.data
        })
        .catch(error => {
            if(error.response) {
                    let url = error.response.config.url?error.response.config.url:'';
                    let status = error.response.status;
                    let message = error.response.data.message ? error.response.data.message : error.response.data.error.message;
                    logger.error(`component: RegisterHotel, url: ${url}, status: ${status}, message: ${message}`, error.stack)
                        .then(() => null)
                } else {
                    logger.error(error.message, error.stack)
                        .then(() => null);
                }
            throw new ExceptionBadResponse();
        });
}

async function createBilling(billing) {
    let token = await storage.getToken();
    return axios.post(endpoint + '/api/services-new/profiles/billings', billing, {
            headers: {
                Authorization: token
            }
        }) // eslint-disable-next-line
        .then(response => null)
        .catch(error => {
            if(error.response) {
                    let url = error.response.config.url?error.response.config.url:'';
                    let status = error.response.status;
                    let message = error.response.data.message ? error.response.data.message : error.response.data.error.message;
                    logger.error(`component: RegisterHotel, url: ${url}, status: ${status}, message: ${message}`, error.stack)
                        .then(() => null)
                } else {
                    logger.error(error.message, error.stack)
                        .then(() => null);
                }
            throw new ExceptionBadResponse();
        });
}
export default {
  createOrganization,
  createBilling,
};
